import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component,
  Input, OnInit, ViewChild,
} from '@angular/core';
import * as _ from 'lodash';
import { Observable } from 'rxjs';

import { BrandService } from 'shared/brand/brand.service';
import { getAvailableLanguages } from 'utils/utils';
import { TeamService } from 'shared/team/team.service';

import { InformationPageService } from '../../../information-page/information-page.service';
import { AccountInformationService } from '../../account-information.service';
import { TEAM_NAME } from '../../variables';

import { BaseAccountSegmentComponent } from '../base/_base-segment.component';
import { TeamFormComponent } from './team-form.component';
import {ProductPanelComponent} from '../../../../product-panel/product-panel.component';


@Component({
  moduleId: module.id,
  selector: 'team-segment',
  template: `
    <team-form
      [brandId]="brandId"
      [data]='data'
      [segmentData]='segmentData'
      (addEditDone)='onAddEditDone()'
      (forceSave)='onFormForceSave()'></team-form>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class TeamComponent extends BaseAccountSegmentComponent implements OnInit {
  name: string = TEAM_NAME;
  brandId: string;

  @ViewChild(TeamFormComponent, {static: false})
  // @ts-ignore
  protected formComponent: TeamFormComponent | void;

  constructor(
    protected accountInformationService: AccountInformationService,
    protected informationPageService: InformationPageService,
    protected teamService: TeamService,
    protected ref: ChangeDetectorRef,
    private brandService: BrandService,
  ) {
    super(
      accountInformationService,
      informationPageService,
      ref,
    );
  }

  /*******************************************
   * COMPONENT GETTERS
   *******************************************/
   // inherited
   get showActionPanel(): boolean {
     // never show action panel on this segment
     return false;
   }

  /*******************************************
   * COMPONENT HOOKS
   *******************************************/

  ngOnInit() {
    super.ngOnInit();
    this.brandId = this.brandService.getBrand();
    this.refresh();
  }

  /*******************************************
   * COMPONENT PUBLIC METHODS
   *******************************************/

  putFormData(): Observable<any> {
    if (!this.formComponent) {
      return;
    }
    const data = this.formComponent.formData.value;

    const dataToRemove = _.differenceWith(this.sourceData, data, (item1: any, item2: any) => {
      return item1.user_id !== null ? item1.user_id === item2.user_id :
        item1.invite_id === item2.invite_id;
    });

    const users = _.filter(dataToRemove, (user: any) => {
      return user.user_id !== null;
    });
    const invitedUsers = _.difference(dataToRemove, users);

    return this.teamService.removeMembers(
      this.brandService.getBrand(),
      users.map((user: any) => {
        return user.user_id;
      }),
      invitedUsers.map((user: any) => {
        return user.invite_id;
      }),
    );
  }

  fetchFormData(): Observable<any> {
    return this.refreshData();
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

   onAddEditDone() {
    this.fetchFormData()
    .subscribe((data: any) => {
      this.setData(data);
    });
  }

  onFormForceSave() {
    if (this.isDirty) {
      this.putFormData()
      .subscribe((res: any) => {
        if (this.form) {
          this.form.markAsPristine();
        }
        this.ref.markForCheck();
      });
    }
  }
}
